// extracted by mini-css-extract-plugin
export default {"header":"Header_header__suzzZ","header__button":"Header_header__button__xvLkH"};